module.exports = __webpack_public_path__ + "static/media/stripe.8a221c39.svg";